import { apiRequest } from "./client";
import type { Dataset } from "../types";

/** v3.1: the signed-in user's own OneDrive / SharePoint (read with THEIR Microsoft access). */
export type OneDriveState = "disabled" | "not_connected" | "connected" | "needs_reconnect" | "not_available_for_your_tenant";

export interface OneDriveStatus {
  enabled: boolean;
  state: OneDriveState;
  scopes: string[];
  account: string | null;
  last_used_at: string | null;
  connected_at: string | null;
  message: string | null;
}

export interface MyDrive { id: string; name: string; driveType?: string | null; webUrl?: string | null }
export interface MySite { id: string; name: string; webUrl?: string | null }
export interface MyItem {
  id: string;
  name: string;
  isFolder: boolean;
  isExcel: boolean;
  size?: number | null;
  modified?: string | null;
  webUrl?: string | null;
  driveId?: string | null;
  childCount?: number | null;
}
export interface MyWorkbookObject { type: string; name: string; source_sheet?: string; worksheet?: string; row_count?: number | null; column_count?: number | null; hidden?: boolean }
export interface PersonalDataset extends Dataset {
  personal_file: boolean;
  file_owner_id: string | null;
  needs_attention: boolean;
  attention_reason: string | null;
}

const BASE = "/api/v1/owner/my-files";
const enc = encodeURIComponent;

export const myFilesApi = {
  status: () => apiRequest<{ onedrive: OneDriveStatus }>("/api/v1/me/data-connections").then((r) => r.onedrive),
  disconnect: () => apiRequest<{ onedrive: OneDriveStatus }>("/api/v1/me/data-connections/disconnect", { method: "POST" }).then((r) => r.onedrive),
  connectUrl: "/auth/graph/start",
  drive: () => apiRequest<{ drive: MyDrive }>(`${BASE}/drive`).then((r) => r.drive),
  children: (driveId: string, itemId?: string) =>
    apiRequest<{ items: MyItem[]; truncated: boolean }>(itemId ? `${BASE}/drives/${enc(driveId)}/items/${enc(itemId)}/children` : `${BASE}/drives/${enc(driveId)}/children`),
  followedSites: () => apiRequest<{ sites: MySite[] }>(`${BASE}/sites/followed`).then((r) => r.sites),
  searchSites: (q: string) => apiRequest<{ sites: MySite[] }>(`${BASE}/sites/search?q=${enc(q)}`).then((r) => r.sites),
  siteDrives: (siteId: string) => apiRequest<{ drives: MyDrive[] }>(`${BASE}/sites/${enc(siteId)}/drives`).then((r) => r.drives),
  sheets: (driveId: string, itemId: string) =>
    apiRequest<{ file: MyItem; objects: MyWorkbookObject[] }>(`${BASE}/drives/${enc(driveId)}/items/${enc(itemId)}/sheets`),
  create: (payload: { name: string; drive_id: string; item_id: string; sheet_name?: string | null }) =>
    apiRequest<{ dataset: PersonalDataset }>(`${BASE}/excel`, { method: "POST", body: payload }),
  datasets: () => apiRequest<PersonalDataset[]>(`${BASE}/datasets`),
};
